import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Divider, TextField, FlatButton, RaisedButton, Card, CardText, Dialog, DatePicker,
  Table, TableHeader, TableRow, TableHeaderColumn, TableBody, TableRowColumn, SelectField, MenuItem,
  Checkbox, IconButton, CircularProgress,
} from "material-ui";
import DateIcon from "material-ui/svg-icons/action/date-range";
import banmedicaTheme from "./../../../config/banmedicaTheme";
import customDateTimeFormat from "../../../helpers/dateFormat";
import {
  OpenConfirmacionGuardadoEdicion, CloseConfirmacionGuardadoEdicion,
  CambiarVigenciaPrestacionEdicion, GuardarValorArancelMod,
  GuardarValorPrestacionesMod, CambiarUnidadGrillaMod, LimpiarErroresGrillaMod,
  CambiarUnidadReplicar, obtenerValorMaxPrestacion, DisplayEditErrorText,
  OpenCargarBorrador, CambiarMontoArancelPrestacion, CambiarMontoArancelError,
  CambiarCheckRowsMod, CambiarCheckRowsModArancel, ShowDupsMsg, ValidarRelacionSecInstitucion,
} from "./actions";
import { CloseEditarPrestacion } from "../GrillaBusqueda/actions";
import { AddPrestacionSolicitud } from "../GrillaSolicitud/actions";

import { ObtenerTiposUnidad, ObtenerTipoProfesional } from "../../Global/actions";
import guid from "../../../helpers/guid";
import styles from "./../../styles/styles";
import valorUnidad from "../../../helpers/valorUnidad";


class EditarPrestacionForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      infoAlert: false,
      infoMensaje: "",
    };
  }

  componentWillMount() {
    this.props.dispatch(ObtenerTiposUnidad());
    this.props.dispatch(ObtenerTipoProfesional());
    this.props.dispatch(obtenerValorMaxPrestacion());

    //this.checkForDups()
  }

  validarRepetida = (prestacionnueva) => {
    let sw = false;
    this.props.prestacionesSolicitud.forEach((prestacion) => {
      if (prestacion.CENTRO_AT === prestacionnueva.CENTRO_AT
        && prestacion.RUTARANCEL === prestacionnueva.RUTARANCEL
        && prestacion.COD_PRESTADOR === prestacionnueva.COD_PRESTADOR
        && prestacion.PROF_CCOD === prestacionnueva.PROF_CCOD
        && prestacion.TIPO_ATENCION === prestacionnueva.TIPO_ATENCION) {
        sw = true;
      }
    });

    return sw;
  };
  CambiarCheckRowsMod = (event, checked, id, rutArancel, centroAtencion) => {
    this.props.dispatch(CambiarCheckRowsMod(checked, id, rutArancel, centroAtencion));
  }

  CambiarCheckRowsModArancel = (checked, arancel) => this.props.dispatch(CambiarCheckRowsModArancel(checked, arancel))

  ocultarModalBorrador = () => {
    this.props.dispatch(OpenCargarBorrador(false));
  }

  CloseEditarPrestacion = () => {
    this.props.dispatch(CambiarUnidadReplicar(null));
    this.props.dispatch(CambiarMontoArancelPrestacion(null));
    this.props.dispatch(CambiarMontoArancelError(null));
    this.props.dispatch(CambiarVigenciaPrestacionEdicion(null));
    this.props.dispatch(CloseEditarPrestacion());
  }

  OpenConfirmacionGuardadoEdicion = () => {
    this.props.dispatch(OpenConfirmacionGuardadoEdicion());
  };

  CloseConfirmacionGuardadoEdicion = () => {
    this.props.dispatch(CloseConfirmacionGuardadoEdicion());
  };

  CambiarVigenciaPrestacionEdicion = (event, date) => {
    /* const dateMin = new Date(Date.now());
    dateMin.setHours(0, 0, 0, 0);
    dateMin.setDate(dateMin.getDate() + this.props.ENV.REACT_APP_REAJUSTAR_ARANCEL_FECHA_VIGENCIA_MINIMA);
    let dateMod = date;
    if (dateMin > date) {
      dateMod = dateMin;
      this.props.dispatch(CambiarVigenciaPrestacionEdicion(
        dateMod,
        `La fecha no puede ser menor a ${dateMin.toLocaleDateString()}`
      ));
    } else { */
    this.props.dispatch(CambiarVigenciaPrestacionEdicion(date /* dateMod */));
    /* } */
  }

  ValidarEdicionSolicitud = () => {
    this.props.dispatch(LimpiarErroresGrillaMod());
    const InicioVigenciaArancel = this.props.vigenciaPrestacionEdicion;
    let exit = false;

    const errors = {
      InicioVigenciaArancelErr: "",
    };
    if (!InicioVigenciaArancel) {
      this.txt_npf_valorPrestacion.focus();
      errors.InicioVigenciaArancelErr = "Seleccionar Inicio de Vigencia";
    }

    if (Object.values(errors).filter((message) => !!message).length > 0) {
      this.props.dispatch(DisplayEditErrorText(errors));
      exit = true;
    }


    if (this.props.valorMaxPres.length > 0) {
      const ValorMax = Number(this.props.valorMaxPres[0].Nombre);

      if (this.props.prestacionesSeleccionadas.filter((p) => p.Selected && p.Valor > ValorMax).length > 0) {
        this.showInfoAlert("El valor Supera lo maximo permitido para una prestación");
        return;
      }
    }

    if (this.props.prestacionesSeleccionadas.filter((p) => p.Selected && (!p.Valor === null || !p.Unidad)).length > 0) {
      this.showInfoAlert("Debe agregar valores y tipo unidad para todas las prestaciones seleccionadas");
      return;
    }


    if (this.props.prestacionesSeleccionadas
      .filter((p) => p.Selected && p.Valor.toString() === p.ValorOld.toString()).length > 0) {
      this.showInfoAlert("El valor a modificar debe ser diferente al existente, favor revisar prestaciones seleccionadas");
      return;
    }

    if (!exit) {
      this.OpenConfirmacionGuardadoEdicion();
    }
  }


  GuardarEdicionSolicitud = () => {
    let hasduplicado = false;

    const inicioVigencia = this.props.vigenciaPrestacionEdicion;
    if (!inicioVigencia) {
      this.props.dispatch(CambiarVigenciaPrestacionEdicion(
        this.props.vigenciaPrestacionEdicion,
        "Debe Agregar Valores Inicio Vigencia Prestacion"
      ));
      return;
    }

    if (this.props.prestacionesSeleccionadas.filter((p) => p.Selected).length === 0) {
      return;
    }

    this.props.prestacionesSeleccionadas.filter((p) => p.Selected).forEach((prestacion) => {
      const nuevaprestacion = {
        COD_PRESTADOR: this.props.detallePrestacion.codigoPrestacionPrestador,
        GLOSA_CODPRESTADOR: this.props.detallePrestacion.glosaPrestacionPrestador,
        GLOSA_GRUPOPRESTADOR: this.props.detallePrestacion.glosagGupoPrestacionIsapre,
        PROF_CCOD: this.props.detallePrestacion.codigoProfesional,
        VALOR: prestacion.Valor,
        UNIDAD: prestacion.Unidad,
        VALOR_ANT: prestacion.ValorOld,
        UNIDAD_ANT: prestacion.UnidadOld,
        TIPO_ATENCION: this.props.detallePrestacion.tipoAtencion,
        INICIO_VIG_PREV: this.props.detallePrestacion.inicioVigenciaArancelPrev,
        INICIO_VIG: this.props.vigenciaPrestacionEdicion,
        FECHA_FIN_VIG: null,
        TIPO_PRESTACION: this.props.detallePrestacion.grupoPrestacionPrestador,
        GUARISMO: this.props.detallePrestacion.pabellonPrestacion,
        PERTENENCIA_FONASA: "",
        CODIGO_FONASA: this.props.detallePrestacion.codigoFonasa,
        COD_ISAPRE: this.props.detallePrestacion.codigoPrestacionIsapre,
        ITEM_IMED: this.props.detallePrestacion.itemImed || "",
        CENTRO_AT: prestacion.DescCentro,
        SECUENCIA: prestacion.centroAtencion,
        ARANCEL: prestacion.DescArancel,
        RUTARANCEL: prestacion.rutArancel,
        IDPRESTACION: prestacion.IdPrestacion,
        OPERACION: "Modifica",
        COD_OPERACION: "3",
        GUID: guid.new(),
      };

      if (!this.validarRepetida(nuevaprestacion)) {
        this.props.CambiosSinGuardar(true);
        this.props.dispatch(AddPrestacionSolicitud(nuevaprestacion));
      } else {
        hasduplicado = true;
      }
    });

    this.props.dispatch(CloseConfirmacionGuardadoEdicion());
    this.CloseEditarPrestacion();
    this.ocultarModalBorrador();
    if (hasduplicado) {
      this.showInfoAlert("Algunas prestaciones ya estaban agregadas");
    }
  }

  GuardarValorArancelMod = (event) => {
    this.props.dispatch(GuardarValorArancelMod(event.target.value, event.target.id));
  };

  ReplicarValoresArancel = () => {
    this.props.prestacionesSeleccionadas.filter((p) => p.Selected).forEach((prestacion) => {
      this.props.dispatch(GuardarValorPrestacionesMod(this.props.detallePrestacion.montoArancelPrestacion, prestacion.IdPrestacion, "", prestacion.rutArancel, prestacion.centroAtencion));
      this.props.dispatch(CambiarUnidadGrillaMod(this.props.tipoUnidadReplicar, prestacion.IdPrestacion, "", prestacion.rutArancel, prestacion.centroAtencion));
    });
  };

  GuardarValorArancel = (unidad, id, rutArancel, centroAtencion, valor) => {
    const validacion = valorUnidad.Validar(valor.toString(), unidad);
    this.props.dispatch(GuardarValorPrestacionesMod(validacion.valor, id, validacion.error, rutArancel, centroAtencion));
  }

  CambiarUnidadGrillaMod = (unidad, id, rutArancel, centroAtencion, valor) => {
    this.GuardarValorArancel(unidad, id, rutArancel, centroAtencion, valor);
    this.props.dispatch(CambiarUnidadGrillaMod(unidad, id, "", rutArancel, centroAtencion));
  }

  CambiarUnidadRep = (unidad, valor) => {
    this.CambiarMontoArancelPrestacion(unidad, valor);
    this.props.dispatch(CambiarUnidadReplicar(unidad));
  }

  CambiarMontoArancelPrestacion = (unidad, valor) => {
    this.props.dispatch(CambiarMontoArancelError(""));

    const validacion = valorUnidad.Validar(valor, unidad);
    if (validacion.error) {
      this.props.dispatch(CambiarMontoArancelError(validacion.error));
    }

    this.props.dispatch(CambiarMontoArancelPrestacion(validacion.valor));
  }

  showInfoAlert = (mensaje) => {
    this.setState({ infoAlert: true, infoMensaje: mensaje });
  }

  checkForDups = () => {
    let alreadyExists = []
    let flag = false
    const { isapre, rutInstitucion } = this.props
    const { tipoAtencion, codigoProfesional, codigoPrestacionPrestador } = this.props.detallePrestacion

    for (const p of this.props.prestacionesSeleccionadas) {
      flag = false
      const prest = {
        isapre,
        rutInstitucion,
        Secuencia: p.centroAtencion,
        rutArancel: p.RutArancel,
        tipoAtencion,
        codigoProfesional,
        codigoPrestacionPrestador,
        //guarismo: codigoProfesional == "AN" || codigoProfesional == "DP" || codigoProfesional == "AR" ? this.props.pabellonPrestacion : null
      }

      if (!alreadyExists.length) alreadyExists.push(prest)
      else {
        for (const ae of alreadyExists) {
          if (JSON.stringify(ae) === JSON.stringify(prest)) {
            flag = true
            break
          }
        }
      }

      if (flag) break
      else alreadyExists.push(prest)
    }

    if (flag) this.props.dispatch(ShowDupsMsg("Hemos detectado prestaciones duplicadas. Favor de contactarse con área de Convenios de la Isapre para solicitar una corrección."))
    else this.props.dispatch(ShowDupsMsg(""))
  }

  render() {
    const { REACT_APP_REAJUSTAR_ARANCEL_FECHA_VIGENCIA_MINIMA: fechaVigenciaPrestador } = this.props.ENV;
    let today = new Date();
    today.setDate(today.getDate() + fechaVigenciaPrestador);
    const minDate = today;

    /* let prestacionesSeleccionadasSorted = this.props.prestacionesSeleccionadas
    let indexOfSelectedPrest = 0
    let selectedPrest = {}

    for (const p of prestacionesSeleccionadasSorted) {
      if (p.IdPrestacion === this.props.detallePrestacion.IdPrestacion) {
        indexOfSelectedPrest = prestacionesSeleccionadasSorted.indexOf(p);
        selectedPrest = p;
        break
      }
    }

    prestacionesSeleccionadasSorted.splice(indexOfSelectedPrest, 1);
    prestacionesSeleccionadasSorted.unshift(selectedPrest); */

    let alreadyExists = []
    let isDup = false
    const { isapre, rutInstitucion } = this.props
    const { tipoAtencion, codigoProfesional, codigoPrestacionPrestador } = this.props.detallePrestacion

    for (const p of this.props.prestacionesSeleccionadas) {
      isDup = false
      const prest = {
        isapre,
        rutInstitucion,
        Secuencia: p.centroAtencion,
        rutArancel: p.rutArancel,
        tipoAtencion,
        codigoProfesional,
        codigoPrestacionPrestador,
        //guarismo: codigoProfesional == "AN" || codigoProfesional == "DP" || codigoProfesional == "AR" ? this.props.pabellonPrestacion : null
      }

      if (!alreadyExists.length) alreadyExists.push(prest)
      else {
        for (const ae of alreadyExists) {
          if (JSON.stringify(ae) === JSON.stringify(prest)) {
            isDup = true
            break
          }
        }
      }

      if (isDup) break
      else alreadyExists.push(prest)
    }

    let glosaTipoProfesional = this.props.detallePrestacion.codigoProfesional;
    if (this.props.tiposProfesionales && this.props.tiposProfesionales.length > 0) {
      const valFilter = this.props.tiposProfesionales.filter((tp) => tp.Tipo === this.props.detallePrestacion.codigoProfesional)[0];
      if (valFilter) glosaTipoProfesional = valFilter.Descripcion;
    }

    const actionsEdicion = [
      <FlatButton
        label="Aun no estoy listo. Seguir modificando"
        primary
        onClick={this.CloseConfirmacionGuardadoEdicion}
      />,
      <FlatButton
        label="Aceptar"
        primary
        onClick={this.GuardarEdicionSolicitud}
      />,
    ];

    const menuListUnidadReplicar = [];
    if (this.props.tiposUnidad) {
      this.props.tiposUnidad.forEach((uni) => {
        menuListUnidadReplicar.push(<MenuItem key={uni.Unidad} value={uni.Unidad} primaryText={uni.Descripcion} style={styles.customWidthItem} />);
      });
    }

    const tableArbol = [];
    const menuListUnidadArbol = [];
    if (this.props.tiposUnidad) {
      this.props.tiposUnidad.forEach((uni) => {
        menuListUnidadArbol.push(<MenuItem key={`unidad_${uni.Unidad}`} value={uni.Unidad} primaryText={uni.Descripcion} style={styles.customWidthItem} />);
      });
    }


    if (this.props.tiposArancelPrestacion && this.props.centrosAtencionPrestacion && this.props.prestacionesSeleccionadas) {
      const prestacionesSeleccionadasTmp = this.props.prestacionesSeleccionadas.filter(p => typeof p != "undefined")
      let checkAll = []

      if (prestacionesSeleccionadasTmp.length > 0) {
        checkAll = (this.props.prestacionesSeleccionadas.length === this.props.prestacionesSeleccionadas.filter((p) => p.Selected).length);
      } else {
        checkAll = (this.props.prestacionesSeleccionadas.length === prestacionesSeleccionadasTmp.length);
      }


      tableArbol.push((
        <Checkbox
          label="Seleccionar Todo"
          id="Selectall"
          key="checkboxTodosCentroAtencion"
          onCheck={this.CambiarCheckRowsMod}
          checked={checkAll}
          style={styles.customWidth}
        />));

      let alreadyAddedIds = []
      this.props.tiposArancelPrestacion.forEach((arancel) => {
        const arbolTipoArancel = [];
        this.props.centrosAtencionPrestacion.forEach((centro) => {
          if (arancel.Rut === centro.Rut) {
            const rowState = this.props.prestacionesSeleccionadas
              .filter((p) => p.rutArancel === arancel.Rut && p.centroAtencion === centro.Secuencia && alreadyAddedIds.indexOf(p.IdPrestacion) == -1);

            const prestacion = rowState && rowState.length > 0 ? rowState[0] : null;

            if (prestacion != null) alreadyAddedIds.push(prestacion.IdPrestacion)

            if (prestacion) {
              arbolTipoArancel.push((
                <TableRow key={`rowCentroAtencion_${arancel.Rut}_${centro.Secuencia}}`} style={{ height: 40 }}>
                  <TableHeaderColumn style={styles.rowPrestacionTablaInferiorCheckSub} />
                  <TableHeaderColumn style={styles.rowPrestacionTablaInferiorCheckSub}>
                    <i className="material-icons">subdirectory_arrow_right</i>
                  </TableHeaderColumn>

                  <TableRowColumn style={styles.rowPrestacionTablaInferiorCheckCC}>
                    <Checkbox
                      key={`checkboxCentroAtencion_${arancel.Rut}_${centro.Secuencia}}`}
                      onCheck={(event, checked) => this.CambiarCheckRowsMod(null, checked, prestacion.IdPrestacion, arancel.Rut, centro.Secuencia)}
                      checked={prestacion && prestacion.Selected}
                    />
                  </TableRowColumn>
                  <TableRowColumn style={styles.rowPrestacionTablaInferior0} title={centro.Descripcion}>{centro.Descripcion}</TableRowColumn>

                  <TableRowColumn style={styles.rowPrestacionTablaInferior}>
                    <div style={styles.floatingClaseSelect2} key={`text_valor_${arancel.Rut}_${centro.Secuencia}}`}> Valor Prestacion </div>
                    <TextField
                      name={`txt_valorpres_${arancel.Rut}_${centro.Secuencia}}`}
                      id={`txt_valorpres_${arancel.Rut}_${centro.Secuencia}}`}
                      ref={`txt_valorpres_${arancel.Rut}_${centro.Secuencia}}`}
                      value={(prestacion && prestacion.Valor) || ""}
                      onChange={(event) => this.GuardarValorArancel((prestacion && prestacion.Unidad), prestacion && prestacion.IdPrestacion, arancel.Rut, centro.Secuencia, event.target.value)}
                      underlineStyle={styles.underlineSelectField}
                      inputStyle={styles.h4}
                      style={styles.selectFieldNuevaPrestacionTablaInferior}
                      errorText={(prestacion && prestacion.ValorError) || ""}
                      errorStyle={{ bottom: "-6px" }}
                    />
                  </TableRowColumn>
                  <TableRowColumn style={styles.rowPrestacionTablaInferior2}>
                    <div style={styles.floatingClaseSelect2} key={`textU_${arancel.Rut}_${centro.Secuencia}}`}>Unidad</div>
                    <SelectField
                      name={`dd_hosp_${arancel.Rut}_${centro.Secuencia}}`}
                      id={`dd_hosp_${arancel.Rut}_${centro.Secuencia}}`}
                      key={`dd_hosp_${arancel.Rut}_${centro.Secuencia}}`}
                      value={prestacion && prestacion.Unidad}
                      errorText={prestacion && prestacion.UnidadHError}
                      onChange={(event, index, value) => prestacion && this.CambiarUnidadGrillaMod(value, prestacion.IdPrestacion, arancel.Rut, centro.Secuencia, ((prestacion && prestacion.Valor) || ""))}
                      labelStyle={styles.h4}
                      underlineStyle={styles.underlineSelectField}
                      style={styles.selectFieldNuevaPrestacionTablaInferior}
                      iconStyle={styles.iconSelectField}
                      menuItemStyle={styles.menuItemStyleSelectField}
                      selectedMenuItemStyle={styles.selectedMenuItemSelectFiueld}
                    >{menuListUnidadArbol}
                    </SelectField>
                  </TableRowColumn>
                </TableRow>
              ));
            }
          }
        });

        const arancelCheckAll = (this.props.prestacionesSeleccionadas.filter((p) => p.rutArancel === arancel.Rut).length ===
          this.props.prestacionesSeleccionadas.filter((p) => p.rutArancel === arancel.Rut && p.Selected).length);

        tableArbol.push((
          <div style={{ width: "930px", overflow: "hidden", textAlign: "center" }} key={`contentArancel_${arancel.Rut}`}>
            <Table
              key={`tableArancel_${arancel.Rut}`}
              title={arancel.Descripcion}
              style={{ width: "930px" }}
              selectable={false}
            >
              <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                <TableRow>
                  <TableHeaderColumn style={styles.rowPrestacionTablaInferiorCheckSub}>
                    <i className="material-icons">subdirectory_arrow_right</i>
                  </TableHeaderColumn>
                  <TableHeaderColumn style={styles.rowPrestacionTablaInferiorCheckTA}>
                    <Checkbox
                      key={`checkboxArancel_${arancel.Rut}`}
                      onCheck={(event, checked) => this.CambiarCheckRowsModArancel(checked, arancel.Rut)}
                      checked={arancelCheckAll}
                    />
                  </TableHeaderColumn>
                  <TableHeaderColumn style={styles.customWidth100}>{arancel.Descripcion}</TableHeaderColumn>
                </TableRow>

              </TableHeader>
              <TableBody
                displayRowCheckbox={false}
                deselectOnClickaway={false}
              // stripedRows
              >
                {arbolTipoArancel}
              </TableBody>
            </Table>
          </div>
        ));
      });
    }

    const cantPrestacionesEditar = this.props.prestacionesSeleccionadas.filter((p) => p.Selected && p.Valor).length;

    return (
      <div style={{ width: 990 }}>
        <div style={styles.frameContenidoGeneral}>
          <Card zDepth={0} style={{ paddingBottom: 0 }}>
            <CardText style={{ paddingBottom: 0 }}>
              <div className="row" style={{ paddingBottom: 0 }}>
                <div className="col-12" style={{ margin: 0, padding: 0 }}>
                  <div style={styles.h1}>Modificar Prestación
                  </div>
                  <div style={styles.h3}>Rut Institución: {this.props.rutInstitucion}
                  </div>
                </div>
              </div>
              <div className="row" style={{ paddingBottom: 0, marginTop: 15 }}>
                <div className="col-5" style={styles.colSelectFieldActualizar}>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Código Prestación Prestador:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.codigoPrestacionPrestador}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Tipo de Prestación:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.glosagGupoPrestacionIsapre}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Tipo de Atención:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.tipoAtencion == "A" ? "AMBULATORIA" : "HOSPITALARIA"}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Item IMED:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.itemImed}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Tipo de Profesional:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {glosaTipoProfesional}
                    </div>
                  </div>
                </div>
                <div className="col-5" style={styles.colSelectFieldActualizar}>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Glosa Prestación Prestador:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.glosaPrestacionPrestador}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Inicio Vigencia Prestación:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      <div className="container">
                        <div className="row">
                          <DatePicker
                            name="dp_npf_inicioVigencia"
                            id="dp_npf_inicioVigencia"
                            mode="landscape"
                            DateTimeFormat={customDateTimeFormat.cl()}
                            locale="es-CL"
                            firstDayOfWeek={1}
                            minDate={minDate}
                            value={this.props.vigenciaPrestacionEdicion}
                            onChange={this.CambiarVigenciaPrestacionEdicion}
                            underlineStyle={styles.underlineSelectField}
                            style={{ ...styles.datepickerStyle, width: "80%" }}
                            inputStyle={styles.h4}
                            errorText={this.props.inicioVigenciaArancelErr || ""}
                          />
                          <DateIcon
                            style={{ float: "right", width: "15%" }}
                            color={banmedicaTheme.palette.accent1Color}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Código Fonasa Informado por Prestador:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.codigoFonasa}
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-12" style={{ padding: 0 }}>
                  <Divider style={{ marginTop: 10, marginBottom: 10 }} />
                </div>
                <div className="col-3" style={styles.colSelectFieldActualizar}>
                  <div style={styles.floatingClaseSelect2}>Valor Prestacion</div>
                  <TextField
                    name="txt_npf_valorPrestacion"
                    id="txt_npf_valorPrestacion"
                    ref={(c) => { this.txt_npf_valorPrestacion = c; }}
                    value={this.props.detallePrestacion.montoArancelPrestacion}
                    onChange={(event) => this.CambiarMontoArancelPrestacion(this.props.tipoUnidadReplicar, event.target.value)}
                    underlineStyle={styles.underlineSelectField}
                    inputStyle={styles.h4}
                    style={styles.selectFieldNuevaPrestacion}
                    errorText={this.props.detallePrestacion.montoArancelError}

                  />
                </div>
                <div className="col-3" style={styles.colSelectFieldActualizar}>
                  <div style={styles.floatingClaseSelect2}>Unidad</div>
                  <SelectField
                    name="dd_replicar_unidad"
                    id="dd_replicar_unidad"
                    key="dd_replicar_unidad"
                    value={this.props.tipoUnidadReplicar}
                    onChange={(event, index, value) => this.CambiarUnidadRep(value, this.props.detallePrestacion.montoArancelPrestacion)}
                    labelStyle={styles.h4}
                    underlineStyle={styles.underlineSelectField}
                    style={styles.selectFieldNuevaPrestacion}
                    iconStyle={styles.iconSelectField}
                    menuItemStyle={styles.menuItemStyleSelectField}
                    selectedMenuItemStyle={styles.selectedMenuItemSelectFiueld}
                  >{menuListUnidadReplicar}
                  </SelectField>
                </div>
                <div className="col-3" style={styles.colSelectFieldActualizar}>
                  <RaisedButton
                    id="222"
                    label="Replicar"
                    onClick={this.ReplicarValoresArancel}
                    secondary
                    labelStyle={{ fontSize: "11px" }}
                    overlayStyle={{ borderRadius: 5 }}
                    rippleStyle={{ borderRadius: 5 }}
                    style={{
                      width: "130px", borderRadius: 5, marginLeft: 20, marginTop: 10,
                    }}
                    buttonStyle={{ borderRadius: 5 }}
                    disabled={!!this.props.detallePrestacion.montoArancelError}
                  />
                </div>
              </div>

              {this.props.loadingArbolDetalle ?
                <CircularProgress></CircularProgress>
                :
                tableArbol
              }

              {
                isDup ?
                  <div className="row">
                    <div className="col-12">
                      <div style={{
                        ...styles.errorBox,
                        float: "right"
                      }}>
                        {
                          `Hemos detectado prestaciones duplicadas. Favor de contactarse con área de Convenios de la Isapre para solicitar una corrección o al siguiente email: ${this.props.isapre == "B" ? "convenios@banmedica.cl" : "convenios@vidatres.cl"}.`
                        }
                      </div>
                    </div>
                  </div>
                  :
                  null
              }

              <div className="row" style={{ marginTop: 10, marginBottom: 10 }}>
                <div className="col-12" style={{ textAlign: "right" }}>
                  <RaisedButton
                    onClick={this.CloseEditarPrestacion}
                    label="Cancelar"
                    backgroundColor="#fff"
                    overlayStyle={{ borderRadius: 5 }}
                    labelStyle={{
                      fontSize: "11px", color: "#757575", paddingLeft: 10, paddingRight: 5,
                    }}
                    style={{ width: "145px", borderRadius: 5 }}
                    buttonStyle={{ border: "2px solid #C3C3C3", borderRadius: 5 }}
                  />
                  <RaisedButton
                    disabled={this.props.prestacionesSeleccionadas.filter((p) => p.Selected).length === 0 ||
                      this.props.prestacionesSeleccionadas.filter((p) => p.Selected && (p.ValorError || p.UnidadError)).length > 0
                      || isDup
                    }
                    onClick={this.ValidarEdicionSolicitud}
                    label="Modificar"
                    secondary
                    labelStyle={{ fontSize: "11px" }}
                    overlayStyle={{ borderRadius: 5 }}
                    rippleStyle={{ borderRadius: 5 }}
                    style={{ width: "130px", borderRadius: 5, marginLeft: 20 }}
                    buttonStyle={{ borderRadius: 5 }}
                  />
                </div>
              </div>
            </CardText>
          </Card>


          <Dialog
            key="dialogConfimacionEdicion"
            id="dialogConfimacionEdicion"
            actions={actionsEdicion}
            modal
            open={this.props.aceptaGuardadoModalEdicion}
            style={{ width: "700px", fontSize: "13px" }}
            title={
              <div>
                <div style={{ float: "right" }}>
                  <IconButton onClick={this.ocultarModalBorrador} >
                    <i className="material-icons" style={{ color: "#fff" }}>close</i>
                  </IconButton>
                </div>
              </div>
            }

          >
            {
              cantPrestacionesEditar > 1 ?
                `Se modificaran ${cantPrestacionesEditar} prestaciones según la combinación de Centros Médicos y Aranceles seleccionados`
                :
                "Se modificará 1 prestación según la combinación de Centro Médico y Arancel seleccionado"
            }
          </Dialog>

          <Dialog
            key="dialogSinCambios"
            id="dialogSinCambios"
            actions={
              <FlatButton
                label="Aceptar"
                primary
                onClick={() => this.setState({ infoAlert: false })}
              />
            }
            modal
            open={this.state.infoAlert}
            style={{ width: "700px", fontSize: "13px" }}
            title={
              <div>
                <div style={{ float: "right" }}>
                  <IconButton onClick={() => this.setState({ infoAlert: false })} >
                    <i className="material-icons" style={{ color: "#fff" }}>close</i>
                  </IconButton>
                </div>
              </div>
            }
          >
            {this.state.infoMensaje}
          </Dialog>

        </div>
      </div>
    );
  }
}


EditarPrestacionForm.defaultProps = {
  vigenciaPrestacionEdicion: null,
  tipoUnidadReplicar: null,
  // montoMaximoFonasa: null,
};

EditarPrestacionForm.propTypes = {
  dupsMsg: PropTypes.string.isRequired,
  rutInstitucion: PropTypes.number.isRequired,
  aceptaGuardadoModalEdicion: PropTypes.bool.isRequired,
  vigenciaPrestacionEdicion: PropTypes.instanceOf(Date),
  // valorPrestacion: PropTypes.number.isRequired,
  centrosAtencionPrestacion: PropTypes.array.isRequired,
  tiposArancelPrestacion: PropTypes.array.isRequired,
  tiposUnidad: PropTypes.array.isRequired,
  tiposProfesionales: PropTypes.array.isRequired,
  prestacionesSeleccionadas: PropTypes.array.isRequired,
  tipoUnidadReplicar: PropTypes.string,
  valorMaxPres: PropTypes.array.isRequired,
  // montoMaximoFonasa: PropTypes.number,
  detallePrestacion: PropTypes.any.isRequired,
  ENV: PropTypes.any.isRequired,
  prestacionesSolicitud: PropTypes.array.isRequired,
  inicioVigenciaArancelErr: PropTypes.string.isRequired,
  loadingArbolDetalle: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  CambiosSinGuardar: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  dupsMsg: state.editarPrestacionForm.dupsMsg,
  isapre: state.global.isapre,
  rutInstitucion: state.global.rutInstitucion,
  aceptaGuardadoModalEdicion: state.editarPrestacionForm.aceptaGuardadoModalEdicion,
  vigenciaPrestacionEdicion: state.editarPrestacionForm.vigenciaPrestacionEdicion,
  valorPrestacion: state.editarPrestacionForm.valorPrestacion,
  centrosAtencionPrestacion: state.editarPrestacionForm.centrosAtencionPrestacion,
  tiposArancelPrestacion: state.editarPrestacionForm.tiposArancelPrestacion,
  tiposUnidad: state.global.tiposUnidad,
  tiposProfesionales: state.global.tiposProfesionales,
  prestacionesSeleccionadas: state.editarPrestacionForm.prestacionesSeleccionadas,
  tipoUnidadReplicar: state.editarPrestacionForm.tipoUnidadReplicar,
  valorMaxPres: state.editarPrestacionForm.valorMaxPres,
  // montoMaximoFonasa: state.global.montoMaximoFonasa,
  detallePrestacion: {
    codigoPrestacionPrestador: state.editarPrestacionForm.detallePrestacion.codigoPrestacionPrestador,
    pabellonPrestacion: state.editarPrestacionForm.detallePrestacion.pabellonPrestacion,
    glosaPrestacionPrestador: state.editarPrestacionForm.detallePrestacion.glosaPrestacionPrestador,
    codigoFonasa: state.editarPrestacionForm.detallePrestacion.codigoFonasa,
    grupoPrestacionIsapre: state.editarPrestacionForm.detallePrestacion.grupoPrestacionIsapre,
    codigoPrestacionIsapre: state.editarPrestacionForm.detallePrestacion.codigoPrestacionIsapre,
    glosaPrestacionIsapre: state.editarPrestacionForm.detallePrestacion.glosaPrestacionIsapre,
    codigoProfesional: state.editarPrestacionForm.detallePrestacion.codigoProfesional,
    montoArancelPrestacion: state.editarPrestacionForm.detallePrestacion.montoArancelPrestacion,
    montoArancelError: state.editarPrestacionForm.detallePrestacion.montoArancelError,
    unidadArancelPrestacion: state.editarPrestacionForm.detallePrestacion.unidadArancelPrestacion,
    inicioVigenciaArancelPrev: state.editarPrestacionForm.detallePrestacion.inicioVigenciaArancelPrev,
    tipoAtencion: state.editarPrestacionForm.detallePrestacion.tipoAtencion,
    grupoPrestacionPrestador: state.editarPrestacionForm.detallePrestacion.grupoPrestacionPrestador,
    itemImed: state.editarPrestacionForm.detallePrestacion.itemImed,
    glosagGupoPrestacionIsapre: state.editarPrestacionForm.detallePrestacion.glosagGupoPrestacionIsapre,
    idPrestacion: state.editarPrestacionForm.detallePrestacion.idPrestacion
  },
  ENV: state.global.ENV,
  prestacionesSolicitud: state.grillaSolicitud.prestacionesSolicitud,
  inicioVigenciaArancelErr: state.editarPrestacionForm.inicioVigenciaArancelErr,
  loadingArbolDetalle: state.editarPrestacionForm.loadingArbolDetalle,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});


export default connect(mapStateToProps, mapDispatchToProps)(EditarPrestacionForm);

